export const CheckHomePage = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
    >
      <path
        d="M37.7095 13.167L18.648 32.2285L9.11719 22.6978"
        stroke="#18C2DE"
        strokeWidth="6.44826"
      />
    </svg>
  );
};
